import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const Card = styled.div`
	width: 100%;
	height: 100%;

	${media.tablet} {
		display: flex;
		flex-direction: row;
		width: 100%;
		margin-top: 40px;
		column-gap: 24px;

		&:first-child {
			margin-top: 0;
		}
	}

	${media.mobile} {
		flex-direction: column;
		row-gap: 24px;
	}
`;

export const HeaderWrapper = styled.div<{ isShort: boolean }>`
	max-width: ${({ isShort = true }) => (isShort ? '220px' : '100%')};

	${media.tablet} {
		max-width: 100%;
	}
`;

export const StyledList = styled.ul`
	box-sizing: border-box;
	max-width: 100%;
	padding-left: 23px;
	margin-top: 12px;
	margin-bottom: 0;
`;

export const StyledListItem = styled.li`
	padding-left: 7px;
	margin-bottom: 17px;

	&:last-child {
		margin-bottom: 0;
	}

	${media.tablet} {
		margin-bottom: 14px;
	}
`;

export const ListItemText = css`
	display: block;
`;

export const imgStyles = css`
	display: block;
	width: 100%;
	height: auto;
	max-height: 256px;
	border-radius: 16px;

	${media.tablet} {
		min-width: 268px;
		width: 268px;
		height: 180px;
	}

	${media.mobile} {
		width: 100%;
		height: auto;
		max-height: 100%;
	}
`;

export const headerStyles = css`
	margin-top: 24px;

	${media.tablet} {
		margin-top: 0;
		font-size: 18px !important;
		line-height: 24px !important;
	}
`;

// !important ^ чтобы перебить стили фронтона
